var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"5q-8CBKbYtAaQsZgVJ3h7"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

/* eslint-disable prettier/prettier */
import * as Sentry from "@sentry/nextjs";
import {
  SENTRY_DSN,
  VAR_ACTIVE_PATHNAME,
  VAR_USER_TOKEN
} from "./config/constants";

let activeTraceId: string | null = null;
let activePathname: string | null = null;

function getSentryUser(): Sentry.User | null {
  try {
    const token = localStorage.getItem(VAR_USER_TOKEN);
    if (!token) return null;
    const payload = JSON.parse(atob(token.split(".")[1]));
    if (!payload?.userId) return null;
    return {
      id: String(payload.userId),
      email: payload.email || payload.sub || undefined,
      username: payload.names || undefined,
      ip_address: "{{auto}}"
    };
  } catch {
    return null;
  }
}

function attachUser(event: Sentry.Event) {
  if (!event.user?.email && !event.user?.id) {
    const user = getSentryUser();
    if (user) event.user = user;
  }
  return event;
}

Sentry.init({
  dsn: SENTRY_DSN,
  tracesSampleRate: 1,
  debug: false,
  replaysOnErrorSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  enableTracing: true,

  beforeSend: (event) => attachUser(event),
  beforeSendTransaction: (event) => attachUser(event),

  integrations: [
    Sentry.replayIntegration({
      maskAllText: true
    }),

    Sentry.browserTracingIntegration({
      tracePropagationTargets: ["localhost", /.*ox\.rw/, /.*ngrok/, /^\//],
      instrumentPageLoad: true,
      beforeStartSpan: (context) => {
        const pathname =
          (Sentry.getCurrentScope().getSpan()?.transaction?.tags
            ?.from as string) || window.location.pathname?.split("?")[0];

        if (activeTraceId && pathname === activePathname) {
          return {
            ...context,
            traceId: activeTraceId,
            name: activePathname
          };
        }

        activeTraceId = context.traceId ?? "";
        activePathname = pathname;
        localStorage.setItem(VAR_ACTIVE_PATHNAME, pathname ?? "");

        return {
          ...context,
          name: pathname
        };
      }
    })
  ]
});

export const onRouterTransitionStart = Sentry.startBrowserTracingPageLoadSpan;
